"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterProductsFromApi = void 0;
/**
 * Filters out products from the API response that do not have an item code. Returns an array of product codes.
 */
const filterProductsFromApi = productsFromApi => productsFromApi.map(product => product.itemCode).filter(itemCode => itemCode != null);
exports.filterProductsFromApi = filterProductsFromApi;
